import { Button, Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { deleteAnnouncement } from '../../api'
import { DelAnnouncementProps } from '../../types'
import { deleteAnnouncementFromList } from '../../slice/announcementslice'

const DelAnnouncement = ({ show, onClose, data }: DelAnnouncementProps) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Delete Announcement"
            body={
                <>
                    <p className="del-desc">
                        Are you sure you want to delete this Announcement ?
                    </p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={async () => {
                                const response = await deleteAnnouncement(
                                    data.id
                                )
                                if (response) {
                                    dispatch(
                                        deleteAnnouncementFromList({
                                            id: data.id,
                                        })
                                    )
                                    dispatch(
                                        SHOW_NOTIFICATION({
                                            type: 'success',
                                            message:
                                                'Announcement deleted successfully',
                                        })
                                    )
                                }
                                onClose(false)
                            }}
                        >
                            YES
                        </Button>
                        <Button
                            type="submit"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DelAnnouncement
